export default function route(page: string) {
  switch (page) {
    case 'kpi-overview':
      import('./pages/kpi/kpi-overview')
      return page

    case 'kpi-dashboard':
      import('./pages/kpi-dashboard/kpi-dashboard')
      return page

    case 'kpi-list':
      import('./pages/kpi/kpi-list-page')
      return page

    case 'kpi-tree':
      import('./pages/kpi/kpi-tree-page')
      return page


    case 'kpi-metric-list':
      import('./pages/kpi-metric/kpi-metric-list-page')
      return page

    case 'kpi-value-list':
      import('./pages/kpi-value/kpi-value-list-page')
      return page

    case 'kpi-value-editor':
      import('./pages/kpi-value/kpi-value-editor-page')
      return page

    case 'kpi-metric-value-list':
      import('./pages/kpi-metric-value/kpi-metric-value-list-page')
      return page

    case 'kpi-metric-value-editor':
      import('./pages/kpi-metric-value/kpi-metric-value-editor-page')
      return page

    case 'kpi-metric-value-manual-entry':
      import('./pages/kpi-metric-value/kpi-metric-value-manual-entry-page')
      return page

    case 'kpi-history-list':
      import('./pages/kpi-history/kpi-history-list-page')
      return page

    case 'kpi-statistic-list':
      import('./pages/kpi-statistic/kpi-statistic-list-page')
      return page

    case 'kpi-statistic-editor':
      import('./pages/kpi-statistic/kpi-statistic-editor-page')
      return page

    case 'kpi-dashboard-map':
      import('./pages/kpi-dashboard/kpi-dashboard-map')
      return page
  }
}
